<form (submit)="saveAndNext()" [formGroup]="form" (keydown.enter)="saveAndNext()" class="main-form">
  <div class="card mb-4">
    @if (airportField === 'depart') {
      <div class="card-header">
        <fa-icon [icon]="faPlaneDeparture"></fa-icon> Informations départ
      </div>
    }
    @if (airportField === 'arrival') {
      <div class="card-header">
        <fa-icon [icon]="faPlaneArrival"></fa-icon> Informations arrivée
      </div>
    }
    <div class="card-body">
      <div class="form-group">
        <label [innerText]="'AIRPORTS.AIRPORT' | translate"></label>
        <app-airport-picker
          [inputName]="'airport' + capitalize(airportField) + 'Id'"
          [defaultValue]="airportId.value"
          [disabled]="form.disabled"
                    [isInvalid]="
                        (form.touched || airportId.touched) && airportId.status === 'INVALID'
                            ? 'danger'
                            : ''
                    "
          (setValueToFormControl)="setValueToFormControl($event)"
          >
        </app-airport-picker>

        @if (
          (form.touched || airportId.touched) &&
          airportId.errors &&
          airportId.errors['required']
          ) {
          <div
            class="text-danger"
            [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
          ></div>
        }
      </div>

      @if (airportId.value) {
        <label [attr.for]="airportField + 'DateTimeLocal'">Date et heure</label>
        <div class="row">
          @for (timeField of timeFields; track timeField) {
            <div class="col-md-6">
              <div class="form-group">
                <div class="input-group">
                  <input
                    class="form-control"
                    [id]="airportField + 'DateTime' + capitalize(timeField)"
                                    [formControlName]="
                                        airportField + 'DateTime' + capitalize(timeField)
                                    "
                    type="datetime-local"
                                    [max]="
                                        airportField === 'depart' &&
                                        getDateTimeFieldForAirport(
                                            airportField === 'depart' ? 'arrival' : 'depart',
                                            timeField
                                        ).value
                                            ? getDateTimeFieldForAirport(
                                                  airportField === 'depart' ? 'arrival' : 'depart',
                                                  timeField
                                              ).value
                                            : ''
                                    "
                                    [min]="
                                        airportField === 'arrival' &&
                                        getDateTimeFieldForAirport('depart', timeField).value
                                            ? getDateTimeFieldForAirport('depart', timeField).value
                                            : '2000-01-01'
                                    "
                                    [class.is-invalid]="
                                        (form.touched || getDateTimeField(timeField).touched) &&
                                        getDateTimeField(timeField).status === 'INVALID'
                                            ? 'danger'
                                            : ''
                                    "
                    (change)="updatedDateTime(timeField)"
                    />
                  <div class="invalid-tooltip">
                    @if (
                      (form.touched || getDateTimeField(timeField).touched) &&
                      getDateTimeField(timeField).errors &&
                      getDateTimeField(timeField).errors['required']
                      ) {
                      <div
                        [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                      ></div>
                    }
                    @if (
                      (form.touched || getDateTimeField(timeField).touched) &&
                      getDateTimeField(timeField).errors &&
                      getDateTimeField(timeField).errors['dateBelowMinimum']
                      ) {
                      <div
                                        [innerText]="
                                            'FORM_VALIDATIONS.MIN_VALUE'
                                                | translate
                                                    : {
                                                          min:
                                                              getDateTimeField(timeField).errors[
                                                                  'dateMinimum'
                                                              ] | date : 'dd/MM/yyyy'
                                                      }
                                        "
                    ></div>
                  }
                </div>
                @if (timeField === 'local') {
                  <span
                    class="input-group-text"
                    appTooltip="Heure locale"
                    >{{ "GENERAL.LT" | translate }}</span
                    >
                  }
                  @if (timeField === 'utc') {
                    <span class="input-group-text">{{
                      "GENERAL.UTC" | translate
                    }}</span>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (airportField === 'arrival' && getEstimatedArrivalTime()) {
          <div
            class="alert alert-info text-center"
            >
            {{
            enquiry?.type === EnumEnquiryType.cargo
            ? "Heure UTC d'arrivée estimée pour"
            : "Heure locale d'arrivée estimée pour"
            }}
            {{ enquiryFlight.aircraftModelTitle }} :
            <div [innerHTML]="getEstimatedArrivalTimeForInfo()"></div>
            @if (getEstimatedArrivalTime().utc !== getDateTimeField('utc').value) {
              <button
                type="button"
                class="btn btn-info btn-sm"
                (click)="applyEstimatedArrivalTime()"
                >
                Appliquer
              </button>
            }
          </div>
        }
        @if (airportField === 'arrival') {
          <div class="d-flex justify-content-center">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="isAircraftGroundedOnArrival"
                formControlName="isAircraftGroundedOnArrival"
                />
              <label class="form-check-label" for="isAircraftGroundedOnArrival"
                >Reste en immobilisation</label
                >
              </div>
            </div>
          }
        }
      </div>
    </div>
    @if (airportId.value) {
      <div class="row">
        <div class="col-md-6">
          <div class="card mb-4">
            <div class="card-header">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  [id]="airportField + 'SlotEnabled'"
                  [formControlName]="airportField + 'SlotEnabled'"
                  (change)="updatedSlotEnabled()"
                  />
                <label class="form-check-label" [attr.for]="airportField + 'SlotEnabled'"
                  >Slot</label
                  >
                </div>
              </div>
              @if (slotEnabled.value) {
                <div class="card-body">
                  <div class="form-group placeholder-glow mb-0">
                    <div class="input-group">
                      <input
                        type="time"
                        class="form-control"
                        [formControlName]="airportField + 'SlotTime'"
                                [class.is-invalid]="
                                    (form.touched || slotTime.touched) &&
                                    slotTime.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                        />
                      <div class="invalid-tooltip">
                        @if (
                          (form.touched || slotTime.touched) &&
                          slotTime.errors &&
                          slotTime.errors['required']
                          ) {
                          <div
                            [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                          ></div>
                        }
                      </div>
                      <span class="input-group-text" appTooltip="Heure locale">{{
                        "GENERAL.LT" | translate
                      }}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          @if (![EnumEnquiryType.business, EnumEnquiryType.helico].includes($safeNavigationMigration(enquiry?.type))) {
            <div
              class="col-md-6"
              >
              <div class="card mb-4">
                <div class="card-header">
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      [id]="airportField + 'TerminalEnabled'"
                      [formControlName]="airportField + 'TerminalEnabled'"
                      (change)="updatedTerminalEnabled()"
                      />
                    <label
                      class="form-check-label"
                      [attr.for]="airportField + 'TerminalEnabled'"
                      >Terminal</label
                      >
                    </div>
                  </div>
                  @if (terminalEnabled.value) {
                    <div class="card-body">
                      <div class="form-group placeholder-glow mb-0">
                        <input
                          type="text"
                          class="form-control"
                          [formControlName]="airportField + 'Terminal'"
                            [class.is-invalid]="
                                (form.touched || terminal.touched) && terminal.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                          />
                        <div class="invalid-tooltip">
                          @if (
                            (form.touched || terminal.touched) &&
                            terminal.errors &&
                            terminal.errors['required']
                            ) {
                            <div
                              [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                            ></div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            @if (![EnumEnquiryType.business, EnumEnquiryType.helico].includes($safeNavigationMigration(enquiry?.type))) {
              <div
                class="col-md-6"
                >
                <div class="card mb-4">
                  <div class="card-header">
                    <div class="handling-switch">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          [id]="airportField + 'HandlingEnabled'"
                          [formControlName]="airportField + 'HandlingEnabled'"
                          (change)="updatedHandlingEnabled()"
                          />
                        <label
                          class="form-check-label"
                          [attr.for]="airportField + 'HandlingEnabled'"
                          [innerText]="'GENERAL.HANDLING' | translate"
                        ></label>
                      </div>
                      @if (hasAclAccess(EnumAcl.handlingsAdd) && handlingEnabled.value) {
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="addHandling()"
                          [appTooltip]="'HANDLINGS.ADD' | translate"
                          >
                          <fa-icon [icon]="faPlusCircle"></fa-icon>
                        </button>
                      }
                    </div>
                  </div>
                  @if (handlingEnabled.value) {
                    <div class="card-body">
                      <div class="form-group placeholder-glow mb-0">
                        @if (loadingHandlingsForAirport[airportId.value]) {
                          <div
                            class="placeholder w-100"
                          ></div>
                        }
                        @if (!loadingHandlingsForAirport[airportId.value]) {
                          <div
                            [class.input-group]="handlingId.value"
                            >
                            <select
                              class="form-select"
                              [formControlName]="airportField + 'HandlingId'"
                                [class.is-invalid]="
                                    (form.touched || handlingId.touched) &&
                                    handlingId.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                              >
                              <option
                                [ngValue]="null"
                                [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
                              ></option>
                              @for (item of handlingsObj[airportId.value]; track item.id) {
                                <option
                                  [value]="item.id"
                                  [innerText]="item.name"
                                ></option>
                              }
                            </select>
                            <div class="invalid-tooltip">
                              @if (
                                (form.touched || handlingId.touched) &&
                                handlingId.errors &&
                                handlingId.errors['required']
                                ) {
                                <div
                                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                                ></div>
                              }
                            </div>
                            @if (hasAclAccess(EnumAcl.handlingsEdit) && handlingId.value) {
                              <button
                                type="button"
                                class="btn btn-primary"
                                (click)="editHandling()"
                                [appTooltip]="'HANDLINGS.EDIT' | translate"
                                >
                                <fa-icon [icon]="faEdit"></fa-icon>
                              </button>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            @if (
              true || [EnumEnquiryType.business, EnumEnquiryType.helico].includes($safeNavigationMigration(enquiry?.type))
              ) {
              <div
                class="col-md-6"
                >
                <div class="card mb-4">
                  <div class="card-header">
                    <div class="fbo-switch">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          [id]="airportField + 'FboEnabled'"
                          [formControlName]="airportField + 'FboEnabled'"
                          (change)="updatedFboEnabled()"
                          />
                        <label class="form-check-label" [attr.for]="airportField + 'FboEnabled'"
                          >FBO</label
                          >
                        </div>
                        @if (hasAclAccess(EnumAcl.fbosAdd) && fboEnabled.value) {
                          <button
                            type="button"
                            class="btn btn-icon"
                            (click)="addFbo()"
                            [appTooltip]="'ENQUIRY_FLIGHT_EDIT.AIRPORT.ADD_FBO' | translate"
                            >
                            <fa-icon [icon]="faPlusCircle"></fa-icon>
                          </button>
                        }
                      </div>
                    </div>
                    @if (fboEnabled.value) {
                      <div class="card-body">
                        <div class="form-group placeholder-glow mb-0">
                          @if (loadingFbosForAirport[airportId.value]) {
                            <div
                              class="placeholder w-100"
                            ></div>
                          }
                          @if (!loadingFbosForAirport[airportId.value]) {
                            <div
                              [class.input-group]="fboId.value"
                              >
                              <select
                                class="form-select"
                                [formControlName]="airportField + 'FboId'"
                                [class.is-invalid]="
                                    (form.touched || fboId.touched) && fboId.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                                >
                                <option
                                  [ngValue]="null"
                                  [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
                                ></option>
                                @for (item of fbosObj[airportId.value]; track item.id) {
                                  <option
                                    [value]="item.id"
                                    [innerText]="item.name"
                                  ></option>
                                }
                              </select>
                              <div class="invalid-tooltip">
                                @if (
                                  (form.touched || fboId.touched) &&
                                  fboId.errors &&
                                  fboId.errors['required']
                                  ) {
                                  <div
                                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                                  ></div>
                                }
                              </div>
                              @if (hasAclAccess(EnumAcl.fbosEdit) && fboId.value) {
                                <button
                                  type="button"
                                  class="btn btn-primary"
                                  (click)="editFbo()"
                                  appTooltip="Éditer FBO"
                                  >
                                  <fa-icon [icon]="faEdit"></fa-icon>
                                </button>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              <div class="col-md-6">
                <div class="card mb-4">
                  <div class="card-header">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        [id]="airportField + 'AgentEnabled'"
                        [formControlName]="airportField + 'AgentEnabled'"
                        (change)="updatedAgentEnabled()"
                        />
                      <label
                        class="form-check-label"
                        [attr.for]="airportField + 'AgentEnabled'"
                        [innerText]="'GENERAL.REPRESENTATIVE' | translate"
                      ></label>
                    </div>
                  </div>
                  @if (agentEnabled.value) {
                    <div class="card-body">
                      <div class="form-group mt-2">
                        <select
                          class="form-select"
                          [formControlName]="airportField + 'AgentType'"
                            [class.is-invalid]="
                                (form.touched || agentType.touched) &&
                                agentType.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                          (change)="updatedAgentType()"
                          >
                          <option
                            [ngValue]="null"
                            [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
                          ></option>
                          @for (agentType of agentTypes; track agentType) {
                            <option
                              [value]="agentType"
                              [innerText]="getEnquiryFlightAgentTypeLabel(agentType)"
                            ></option>
                          }
                        </select>
                        <div class="invalid-tooltip">
                          @if (
                            (form.touched || agentType.touched) &&
                            agentType.errors &&
                            agentType.errors['required']
                            ) {
                            <div
                              [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                            ></div>
                          }
                        </div>
                      </div>
                      @if (agentType.value === EnumEnquiryFlightAgentType.internal) {
                        <div
                          class="form-group placeholder-glow"
                          >
                          @if (loadingUsers) {
                            <div class="placeholder w-100"></div>
                          }
                          @if (!loadingUsers) {
                            <select
                              class="form-select"
                              [formControlName]="airportField + 'AgentUserId'"
                            [class.is-invalid]="
                                (form.touched || agentUserId.touched) &&
                                agentUserId.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                              (change)="updatedAgentUserId()"
                              >
                              <option
                                [ngValue]="null"
                                [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
                              ></option>
                              @for (user of displayedUsers; track user.id) {
                                <option
                                  [value]="user.id"
                                  [innerText]="getUserFullname(user) + ' (' + user.initials + ')'"
                                ></option>
                              }
                            </select>
                          }
                          <div class="invalid-tooltip">
                            @if (
                              (form.touched || agentUserId.touched) &&
                              agentUserId.errors &&
                              agentUserId.errors['required']
                              ) {
                              <div
                                [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                              ></div>
                            }
                          </div>
                        </div>
                      }
                      @if (
                        agentType.value === EnumEnquiryFlightAgentType.external ||
                        (agentType.value === EnumEnquiryFlightAgentType.internal &&
                        agentUserId.value)
                        ) {
                        <div class="form-group">
                          <label
                            [attr.for]="airportField + 'AgentUserFullName'"
                            [innerText]="'USERS.LASTNAME' | translate"
                          ></label>
                          <input
                            type="text"
                            class="form-control"
                            [id]="airportField + 'AgentUserFullName'"
                            [formControlName]="airportField + 'AgentUserFullName'"
                                [class.is-invalid]="
                                    (form.touched || agentUserFullName.touched) &&
                                    agentUserFullName.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                            />
                          <div class="invalid-tooltip">
                            @if (
                              (form.touched || agentUserFullName.touched) &&
                              agentUserFullName.errors &&
                              agentUserFullName.errors['required']
                              ) {
                              <div
                                [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                              ></div>
                            }
                          </div>
                        </div>
                        <div class="form-group">
                          <label
                            [attr.for]="airportField + 'AgentCompany'"
                            [innerText]="'INVOICE.COMPANY' | translate"
                          ></label>
                          <input
                            type="text"
                            class="form-control"
                            [id]="airportField + 'AgentCompany'"
                            [formControlName]="airportField + 'AgentCompany'"
                                [class.is-invalid]="
                                    (form.touched || agentCompany.touched) &&
                                    agentCompany.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                            />
                          <div class="invalid-tooltip">
                            @if (
                              (form.touched || agentCompany.touched) &&
                              agentCompany.errors &&
                              agentCompany.errors['required']
                              ) {
                              <div
                                [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                              ></div>
                            }
                          </div>
                        </div>
                        <div class="form-group">
                          <label
                            [attr.for]="airportField + 'AgentPhone'"
                            [innerText]="'USERS.PHONE' | translate"
                          ></label>
                          <input
                            type="text"
                            class="form-control"
                            [id]="airportField + 'AgentPhone'"
                            [formControlName]="airportField + 'AgentPhone'"
                                [class.is-invalid]="
                                    (form.touched || agentPhone.touched) &&
                                    agentPhone.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                            />
                          <div class="invalid-tooltip">
                            @if (
                              (form.touched || agentPhone.touched) &&
                              agentPhone.errors &&
                              agentPhone.errors['required']
                              ) {
                              <div
                                [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                              ></div>
                            }
                          </div>
                        </div>
                        <div class="form-group">
                          <label
                            [attr.for]="airportField + 'AgentEmail'"
                            [innerText]="'USERS.EMAIL' | translate"
                          ></label>
                          <input
                            type="text"
                            class="form-control"
                            [id]="airportField + 'AgentEmail'"
                            [formControlName]="airportField + 'AgentEmail'"
                                [class.is-invalid]="
                                    (form.touched || agentEmail.touched) &&
                                    agentEmail.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                            />
                          <div class="invalid-tooltip">
                            @if (
                              (form.touched || agentEmail.touched) &&
                              agentEmail.errors &&
                              agentEmail.errors['required']
                              ) {
                              <div
                                [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                              ></div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              @if (airportField === 'depart') {
                <div class="col-md-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          [id]="airportField + 'ClientContactEnabled'"
                          [formControlName]="airportField + 'ClientContactEnabled'"
                          (change)="updatedClientContactEnabled()"
                          />
                        <label
                          class="form-check-label"
                          [attr.for]="airportField + 'ClientContactEnabled'"
                          [innerText]="'FLIGHT_BRIEF.CONTACT_CLIENT' | translate"
                        ></label>
                      </div>
                    </div>
                    @if (clientContactEnabled.value) {
                      <div class="card-body">
                        <div class="form-group">
                          <label
                            [attr.for]="airportField + 'ClientContactFullName'"
                            [innerText]="'USERS.LASTNAME' | translate"
                          ></label>
                          <input
                            type="text"
                            class="form-control"
                            [id]="airportField + 'ClientContactFullName'"
                            [formControlName]="airportField + 'ClientContactFullName'"
                            [class.is-invalid]="
                                (form.touched || clientContactFullName.touched) &&
                                clientContactFullName.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                            />
                          <div class="invalid-tooltip">
                            @if (
                              (form.touched || clientContactFullName.touched) &&
                              clientContactFullName.errors &&
                              clientContactFullName.errors['required']
                              ) {
                              <div
                                [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                              ></div>
                            }
                          </div>
                        </div>
                        <div class="form-group">
                          <label
                            [attr.for]="airportField + 'ClientContactPhone'"
                            [innerText]="'USERS.PHONE' | translate"
                          ></label>
                          <input
                            type="text"
                            class="form-control"
                            [id]="airportField + 'ClientContactPhone'"
                            [formControlName]="airportField + 'ClientContactPhone'"
                            [class.is-invalid]="
                                (form.touched || clientContactPhone.touched) &&
                                clientContactPhone.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                            />
                          <div class="invalid-tooltip">
                            @if (
                              (form.touched || clientContactPhone.touched) &&
                              clientContactPhone.errors &&
                              clientContactPhone.errors['required']
                              ) {
                              <div
                                [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                              ></div>
                            }
                          </div>
                        </div>
                        <div class="form-group">
                          <label
                            [attr.for]="airportField + 'ClientContactEmail'"
                            [innerText]="'USERS.EMAIL' | translate"
                          ></label>
                          <input
                            type="text"
                            class="form-control"
                            [id]="airportField + 'ClientContactEmail'"
                            [formControlName]="airportField + 'ClientContactEmail'"
                            [class.is-invalid]="
                                (form.touched || clientContactEmail.touched) &&
                                clientContactEmail.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                            />
                          <div class="invalid-tooltip">
                            @if (
                              (form.touched || clientContactEmail.touched) &&
                              clientContactEmail.errors &&
                              clientContactEmail.errors['required']
                              ) {
                              <div
                                [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                              ></div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }

          @if (!form.disabled && blockingValidationError; as validationError) {
            <div
              class="alert alert-danger"
              >
              <strong [innerText]="'ENQUIRY_FLIGHT_EDIT.AIRPORT.NEXT_BLOCKED' | translate"></strong>
              <span>
                {{ validationError.fieldLabelTranslationKey | translate }} :
                {{ validationError.errorTranslationKey | translate : validationError.errorTranslationParams }}
              </span>
            </div>
          }

          <div class="row mb-4">
            <div class="col">
              <button
                type="button"
                class="btn btn-secondary"
                [disabled]="form.disabled"
                (click)="prev()"
                >
                <fa-icon [icon]="faArrowLeft"></fa-icon>
                {{ "GENERAL.PREVIOUS" | translate }}
              </button>
            </div>
            <div class="col text-end">
              <button
                type="button"
                class="btn btn-primary"
                [disabled]="form.disabled || !form.valid"
                (click)="saveAndNext()"
                >
                {{ "GENERAL.NEXT" | translate }}
                <fa-icon [icon]="faArrowRight"></fa-icon>
              </button>
            </div>
          </div>
        </form>

        <div class="modal" tabindex="-1" role="dialog" #modalFbo>
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5
                  class="modal-title"
                    [innerText]="
                        editingFbo
                            ? ('ENQUIRY_FLIGHT_EDIT.AIRPORT.EDIT_FBO' | translate)
                            : ('ENQUIRY_FLIGHT_EDIT.AIRPORT.ADD_FBO' | translate)
                    "
                ></h5>
                <button
                  type="button"
                  class="btn-close"
                  [attr.aria-label]="'GENERAL.CLOSE' | translate"
                  (click)="dismissFboModal()"
                ></button>
              </div>
              @if (airportField) {
                <app-fbo-edit
                  [inModal]="true"
                  [defaultAirportId]="form.get('airport' + capitalize(airportField) + 'Id').value"
                  [fboId]="editingFbo?.id || null"
                  (dismissModal)="dismissFboModal($event)"
                ></app-fbo-edit>
              }
            </div>
          </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" #modalHandling>
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5
                  class="modal-title"
                    [innerText]="
                        editingHandling
                            ? ('ENQUIRY_FLIGHT_EDIT.AIRPORT.EDIT_HANDLING' | translate)
                            : ('ENQUIRY_FLIGHT_EDIT.AIRPORT.ADD_HANDLING' | translate)
                    "
                ></h5>
                <button
                  type="button"
                  class="btn-close"
                  [attr.aria-label]="'GENERAL.CLOSE' | translate"
                  (click)="dismissHandlingModal()"
                ></button>
              </div>
              @if (airportField) {
                <app-handling-edit
                  [inModal]="true"
                  [defaultAirportId]="form.get('airport' + capitalize(airportField) + 'Id').value"
                  [handlingId]="editingHandling?.id || null"
                  (dismissModal)="dismissHandlingModal($event)"
                ></app-handling-edit>
              }
            </div>
          </div>
        </div>
